import App from 'app/app.js';
import 'app/action/ResetJobAction.js';
function SmileSafeStore($http, $q, ResetJobAction) {
  var termsConditionsFlag = false,
    dsskCardDownloadCollection = [],
    smileSafeRequests = [];

  this.clearAll = function () {
    termsConditionsFlag = false;
    dsskCardDownloadCollection = [];
  };

  this.loadDsskCardDownLoads = function (identifier) {
    var dfd = $q.defer(),
      url = 'smileSafe/load/' + identifier;

    // clear everything out before trying to load information for a new identifier
    this.clearAll();
    $http
      .get(url)
      .then(
        function (response) {
          if (!response.data.success) {
            dfd.reject(response.data.error);
          } else {
            dsskCardDownloadCollection = response.data.data.dsskCardDownloadCollection;
            dfd.resolve();
          }
        }.bind(this)
      )
      .catch(function () {
        dfd.reject('DSSK_DOWNLOAD_FAIL_GENERIC_MESSAGE');
      });
    return dfd.promise;
  };

  this.getDsskCardDownLoads = function () {
    return dsskCardDownloadCollection;
  };

  this.getTermsConditionsFlag = function () {
    return termsConditionsFlag;
  };

  this.setTermsConditionsFlag = function (value) {
    termsConditionsFlag = value;
  };

  this.canDownload = function (value) {
    return !!dsskCardDownloadCollection.digitalSmileSafeKidsCardDownloads && termsConditionsFlag;
  };

  this.getSmileSafeRequests = function () {
    return smileSafeRequests;
  };

  this.addSmileSafeRequest = function (smileSafeRequest) {
    smileSafeRequests.push(smileSafeRequest);
  };

  this.clearSmileSafeRequests = function () {
    smileSafeRequests = [];
  };

  ResetJobAction.register(this.clearAll.bind(this));
}

App.service('SmileSafeStore', ['$http', '$q', 'ResetJobAction', SmileSafeStore]);
